import { render, staticRenderFns } from "./SinglePost.vue?vue&type=template&id=5b5eb7b8&"
import script from "./SinglePost.vue?vue&type=script&lang=js&"
export * from "./SinglePost.vue?vue&type=script&lang=js&"
import style0 from "./SinglePost.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SinglePost.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports